import React, { useEffect } from "react";
import { useAppSelector } from "store/rootReducer";

const IframeFinishRedirect = () => {
  const { user } = useAppSelector((state) => state.user);

  useEffect(() => {
    try {
      const queryString = window.location.search;

      if (!user) {
        const redirectUrl = "/MeetingRoomExit";

        if (window.parent && window.parent !== window) {
          window.parent.location.href = redirectUrl;
        } else {
          window.location.href = redirectUrl;
        }
      } else {
        const redirectUrl = `/audiences${queryString || ""}`;

        if (window.parent && window.parent !== window) {
          window.parent.location.href = redirectUrl;
        } else {
          window.location.href = redirectUrl;
        }
      }
    } catch {
      if (!user) {
        window.location.href = "/MeetingRoomExit";
      } else {
        window.location.href = "/audiences";
      }
    }
  }, [user]);

  return null;
};

export default IframeFinishRedirect;
